/* import __COLOCATED_TEMPLATE__ from './phone-number-input.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { PhoneFormatter, TextField } from 'field-kit';
import { getPhoneNumberPlaceholder } from './phone-number-util';
const US_COUNTRY_CODE = 'US';
let PhoneNumberInput = (_class = class PhoneNumberInput extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
    _initializerDefineProperty(this, "phoneNumberPlaceholder", _descriptor3, this);
  }
  async initializeFieldKit(marketInputTextElement) {
    const countryCode = this.userInfo.countryCode;
    this.phoneNumberPlaceholder = getPhoneNumberPlaceholder(countryCode);
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = countryCode === US_COUNTRY_CODE ? new PhoneFormatter() : this.formatter.getPhoneNumberFormatter();
    if (this.args.initialValue) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(this.args.initialValue);
    }
    const fieldKit = new TextField(inputElement, formatter);
    const textDidChange = field => {
      this.args.onValueChange(field.value());
    };
    fieldKit.setDelegate({
      textDidChange
    });
  }
  handleNextButtonClick() {
    this.args.onNextButtonClick(this.userInfo.countryCode);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberPlaceholder", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleNextButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleNextButtonClick"), _class.prototype), _class);
export { PhoneNumberInput as default };